import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "OwaYammerBootstrap" */ './lazyIndex')
);

// Delay loaded imports
export const lazyBootstrapYammer = new LazyImport(lazyModule, m => m.bootstrapYammerIfNeeded);
